/*
 * Author: Dw
 * File Created: Sunday, 24-09-22 09:10 pm
 * Last Modified: Friday, 25-06-27 02:50 pm, by Dw
 */

import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { getOpenApiSession, isOpenApi } from '@ucard/next-core/utils';
const useOpenApi = () => {
  const session = useMemo(() => {
    return getOpenApiSession();
  }, []);
  const router = useRouter();
  const {
    secret
  } = router.query;
  const isOpenApiMode = Boolean(session.externalUserId) || Boolean(secret);
  return {
    session,
    isOpenApiMode: isOpenApi || isOpenApiMode
  };
};
export default useOpenApi;